import React from 'react';

const Disclaimer = () => {
    return (
        <div className="login-disclaimer">
            <h4>Login Disclaimer</h4>
            <p>
                <strong>PRE WARNING:</strong> Unauthorized access or use is prohibited and subject to prosecution and/or disciplinary action. All use of this system constitutes consent to monitoring at all times and users are not entitled to any expectation of privacy. If monitoring reveals possible evidence of violation of criminal statutes, this evidence and any other related information, including identification information about the user, may be provided to law enforcement officials. If monitoring reveals violations of security regulations or unauthorized use, employees who violate security regulations or make unauthorized use of this system are subject to appropriate disciplinary action.
            </p>
        </div>
    );
};

export default Disclaimer;